// extracted by mini-css-extract-plugin
module.exports = {"image":"Pic_image__2vTho","floatBubble":"Pic_floatBubble__1dLQ6","floatBubbleMobile":"Pic_floatBubbleMobile__25q8a"};